export const SPR_TOKEN = 'SPR__TOKEN'



// WEBPACK FOOTER //
// ./src/constant.js